import {IDevice, IDeviceAPI, IDeviceQuery, ILocation} from 'interfaces';
import {axiosAPI} from './API';
import { LoadState } from 'enums';

// Singleton for interacting with devices
class _DevicesService {

    public devicesPageCache: IDevice[] = [];

    public getDevices = (thingIDs: string[]): Promise<IDevice[]> => {

        const p = axiosAPI.post<IDeviceAPI[]>('/devices/get', {thingIDs: thingIDs})
            .then((resp) => {
                var devices = resp.data.map(this.mapDeviceFromServer);
                return devices;
            });
            
        p.catch((err) => {
            console.error('Error getting devices: ', err);
        });

        return p;
    }

    public searchDevices = (query: IDeviceQuery): Promise<IDevice[]> => {

        const p = axiosAPI.post<IDeviceAPI[]>('/devices/search', query)
            .then((resp) => {
                var devices = resp.data.map(this.mapDeviceFromServer);
                return devices;
            });
            
        p.catch((err) => {
            console.error('Error searching devices: ', err);
        });

        return p;
    }

    public mapDeviceFromServer = (d: IDeviceAPI): IDevice => {
        return {
            ...d,
            lastSeen: d.lastSeen ? new Date(d.lastSeen) : undefined,
            pingStatus: LoadState.Initial,
        }
    }
}

export const DevicesService = new _DevicesService();
